import {
    checkFeatureFlagGate,
    featureFlags
} from "@/utils/feature-flags/index.ts";

export const getIsGwp10385 = () =>
    checkFeatureFlagGate(featureFlags.gwp10385PricingSeoDetailsCleanup);
